import { render, staticRenderFns } from "./CadastroFornecedorPessoa.vue?vue&type=template&id=7b91f0cf"
import script from "./CadastroFornecedorPessoa.vue?vue&type=script&lang=js"
export * from "./CadastroFornecedorPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports